import axios from 'axios';
import { loginRequest, loginRequest_api } from "../authConfig";

export const getApiToken = async (msalInstance, accounts) => {
    if (!msalInstance || !accounts || accounts.length === 0) {
        return null;
    }
    
    try {
        const account = accounts[0];
        if (account) {
            const response = await msalInstance.acquireTokenSilent({
                ...loginRequest_api,
                account: account
            });
            if (response) {
                return response.accessToken;
            }
        }
    } catch (error) {
        console.error('Error acquiring token:', error);

        if (error.toString().includes('AADSTS50058')) {
            try {
                // Fallback to interactive login
                console.log('Silent token acquisition failed, attempting interactive login...');
                const interactiveResponse = await msalInstance.acquireTokenRedirect({
                    ...loginRequest_api,
                    account: accounts[0]
                });
                
                if (interactiveResponse) {
                    return interactiveResponse.accessToken;
                }
            } catch (interactiveError) {
                console.error('Interactive token acquisition failed:', interactiveError);
                throw interactiveError;
            }
        }
    }
    return null;
};

export const loginRedirect = async (msalInstance) => {
    if (!msalInstance) {
        throw new Error('MSAL instance is required');
    }

    try {
        console.log('Initiating login redirect...' + JSON.stringify(loginRequest));
        await msalInstance.loginRedirect(loginRequest);
        // Note: After redirect, the page will reload, so the code below won't execute
        // Token acquisition should be handled after the redirect completes
    } catch (error) {
        console.error('Login redirect error:', error);
        throw error;
    }
};
export const logout = async (msalInstance) => {
    if (!msalInstance) {
        throw new Error('MSAL instance is required');
    }

    try {
        const activeAccount = msalInstance.getActiveAccount();
        await msalInstance.logoutRedirect({ 
            account: activeAccount 
        });
    } catch (error) {
        console.error('Logout error:', error);
        throw error;
    }
};

export const getPermissions = async (msalInstance, accounts, updateUserInfo = null) => {
    // Implement your permission fetching logic here
    // This is a placeholder - adjust according to your API
    try {
        const token = await getApiToken(msalInstance, accounts);
        if (token) {

            const response = await axios.get(`${process.env.REACT_APP_serverEndpoint}/User/GetPermissions`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            if (response.data.success) {
                const resultSet = response.data.result_set;

                // Update localStorage (fallback for components that don't use context yet)
                localStorage.setItem('permissions', JSON.stringify(resultSet?.permissions || []));
                localStorage.setItem('roles', JSON.stringify(resultSet?.roles || []));
                localStorage.setItem('traininggroupId', JSON.stringify(resultSet?.traininggroupId));
                localStorage.setItem('traininggroupName', JSON.stringify(resultSet?.traininggroupName));
                localStorage.setItem('logo', resultSet?.logo || '');
                localStorage.setItem('tenants', JSON.stringify(resultSet?.tenants || []));
                localStorage.setItem('selectedTenant', resultSet.selectedTenant);
                localStorage.setItem('navigation', JSON.stringify(resultSet?.navigation || []));

                // Update context if provided
                if (updateUserInfo) {
                    updateUserInfo({
                        logo: resultSet?.logo || null,
                        tenants: resultSet?.tenants || [],
                        permissions: resultSet?.permissions || [],
                        roles: resultSet?.roles || [],
                        traininggroupId: resultSet?.traininggroupId || null,
                        traininggroupName: resultSet?.traininggroupName || null,
                        selectedTenant: resultSet?.selectedTenant || null,
                        navigation: resultSet?.navigation || []
                    });
                }

                return resultSet;

            } else {
                localStorage.setItem('permissions', "[]");
                localStorage.setItem('roles', "[]");
                localStorage.setItem('navigation', "[]");

                if (updateUserInfo) {
                    updateUserInfo({
                        permissions: [],
                        roles: [],
                        navigation: []
                    });
                }

                return null;
            }
        }
    } catch (error) {
        console.error('Get permissions error:', error);
        return null;
    }
};
